export const Agenda = () => {
    return (
        <div className="generic_page">

        </div>
    )
}